import { render, staticRenderFns } from "./BasicDropdownContainer.vue?vue&type=template&id=31df940c&scoped=true&"
import script from "./BasicDropdownContainer.vue?vue&type=script&lang=ts&"
export * from "./BasicDropdownContainer.vue?vue&type=script&lang=ts&"
import style0 from "./BasicDropdownContainer.vue?vue&type=style&index=0&id=31df940c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df940c",
  null
  
)

export default component.exports